module.exports = __webpack_public_path__ + "img/templates-selected.7aa12ef8.png";